<abs-modals-and-alerts-component [(modalAction)]="openModal" (modalClosed)="close($event, 'openModal')"
  windowClass="modal-docked" sizeClass="modal-small">
  <abs-modals-and-alerts-content-component id="delete-confirmation-modal-popup">
    <div class="modal-header">
      <h1 style="display:none;">Fix for sonar issues</h1>
      <h2 id="delete-file-modal-container" modal-title>
        {{cfetLabels.cfet_doc_upload.file_delete_heading}} :<br><strong>{{selectedFile}}?</strong></h2>
      <div class="corner-button">
        <button type="button" class="close-modal-button" tabindex="0" [attr.aria-label]="'Close'"
          (click)="close($event, 'openModal')" (keyup)="close($event,'openModal')">
          <em aria-label="Close" class="icon-close modal-close-icon" role="img"></em>
        </button>
      </div>
    </div>
    <div class="modal-body" id="confirmation-buttons-section" modal-content>
      <div class="row" id="confirmation-buttons">
        <div class="col-md-6">
          <button type="button" id="btn-cancel" (click)="cancel($event,'openModal')"
            (keyup.enter)="cancel($event,'openModal')" class="btn btn-alt btn-medium" tabindex="0">
            <em aria-label=""></em>{{cfetButtonLabels.button_labels.cancel}}</button>
        </div>
        <div class="col-md-6">
          <button type="button" id="btn-delete" (click)="delete($event,'openModal')"
            (keyup.enter)="delete($event,'openModal')" class="btn btn-alt btn-medium" tabindex="0">
            <em aria-label=""></em>{{cfetButtonLabels.button_labels.delete}}</button>
        </div>
      </div>
    </div>
  </abs-modals-and-alerts-content-component>
</abs-modals-and-alerts-component>